import { c as _c } from "react/compiler-runtime";
import { spacing, theme } from '@cc-shopping/ui/theme';
import { ListItem, ListItemButton } from '@mui/material';
type TocItemType = {
  sectionID: string;
  sectionTitle: string;
  onClickAnalyticsCallback: () => void;
};
export function TocItem(t0) {
  const $ = _c(9);
  const {
    sectionID,
    sectionTitle,
    onClickAnalyticsCallback
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      padding: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `#${sectionID}`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = spacing(1);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = spacing(2);
    t5 = spacing(4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      borderLeft: `${t3} solid transparent`,
      padding: `${t4} ${t5}`,
      "&:hover": {
        borderLeft: `${spacing(1)} solid ${theme.palette.blues.main}}`
      }
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== onClickAnalyticsCallback || $[6] !== sectionTitle || $[7] !== t2) {
    t7 = <ListItem sx={t1}><ListItemButton href={t2} sx={t6} onClick={onClickAnalyticsCallback} rel="nofollow noopener noreferrer" target="_self">{sectionTitle}</ListItemButton></ListItem>;
    $[5] = onClickAnalyticsCallback;
    $[6] = sectionTitle;
    $[7] = t2;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}